document.documentElement.classList.remove('no-js');
document.addEventListener('click', function (event) {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (toggle) {
    const nav = document.querySelector('[data-mobile-menu]');
    const open = nav.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? 'Menü schließen' : 'Menü öffnen');
    document.body.classList.toggle('mobile-menu-open', open);
  }
  const submenuToggle = event.target.closest('[data-mobile-submenu-toggle]');
  if (submenuToggle) {
    const submenu = document.getElementById(submenuToggle.getAttribute('aria-controls'));
    const open = submenuToggle.getAttribute('aria-expanded') !== 'true';
    submenuToggle.setAttribute('aria-expanded', String(open));
    submenuToggle.textContent = open ? '−' : '+';
    if (submenu) submenu.hidden = !open;
  }
  const add = event.target.closest('[data-ajax-add]');
  if (add) add.classList.add('is-loading');
});

document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape') return;
  const nav = document.querySelector('[data-mobile-menu]');
  const toggle = document.querySelector('[data-menu-toggle]');
  if (!nav || !toggle || !nav.classList.contains('is-open')) return;
  nav.classList.remove('is-open');
  toggle.setAttribute('aria-expanded', 'false');
  toggle.setAttribute('aria-label', 'Menü öffnen');
  document.body.classList.remove('mobile-menu-open');
  toggle.focus();
});

document.addEventListener('change', function (event) {
  const shopVariant = event.target.closest('[data-shop-variant]');
  if (shopVariant) {
    const option = shopVariant.options[shopVariant.selectedIndex];
    const productInfo = shopVariant.closest('.product-info');
    const price = productInfo && productInfo.querySelector('[data-product-price]');
    const compare = productInfo && productInfo.querySelector('[data-product-compare]');
    const saleLabel = productInfo && productInfo.querySelector('[data-sale-label]');
    const button = productInfo && productInfo.querySelector('[data-shop-add]');
    const stock = productInfo && productInfo.querySelector('[data-product-stock]');
    const available = option.dataset.available === 'true';
    const onSale = option.dataset.onSale === 'true';
    if (price) price.textContent = option.dataset.price || '';
    if (price) price.classList.toggle('sale-price', onSale);
    if (compare) {
      compare.textContent = option.dataset.compare || '';
      compare.classList.toggle('is-hidden', !onSale);
    }
    if (saleLabel) saleLabel.classList.toggle('is-hidden', !onSale);
    if (button) {
      button.disabled = !available;
      button.textContent = available ? 'In den Warenkorb' : 'Derzeit nicht verfügbar';
    }
    if (stock) stock.textContent = available ? 'Sofort bestellbar' : 'Derzeit nicht verfügbar';
    window.history.replaceState({}, '', window.location.pathname + '?variant=' + shopVariant.value);
  }
  const select = event.target.closest('[data-inquiry-variant]');
  if (!select) return;
  const panel = select.closest('.info-panel');
  const link = panel && panel.querySelector('[data-inquiry-link]');
  if (!link) return;
  const params = new URLSearchParams();
  params.set('produkt', link.dataset.productTitle || '');
  params.set('variante', select.value);
  link.href = '/pages/contact?' + params.toString() + '#anfrageformular';
});

document.addEventListener('DOMContentLoaded', function () {
  const searchToggle = document.querySelector('[data-search-toggle]');
  const searchPanel = document.querySelector('[data-header-search]');
  const searchClose = document.querySelector('[data-search-close]');
  const searchInput = document.querySelector('[data-predictive-search-input]');
  const searchResults = document.querySelector('[data-predictive-search-results]');
  let searchTimer;
  let searchRequest;
  const defaultSearchContent = searchResults ? searchResults.innerHTML : '';

  function setSearchOpen(open) {
    if (!searchToggle || !searchPanel) return;
    searchPanel.hidden = !open;
    searchToggle.setAttribute('aria-expanded', String(open));
    searchToggle.setAttribute('aria-label', open ? 'Suche schließen' : 'Suche öffnen');
    document.body.classList.toggle('header-search-open', open);
    if (open) {
      const mobileMenu = document.querySelector('[data-mobile-menu]');
      const menuToggle = document.querySelector('[data-menu-toggle]');
      if (mobileMenu) mobileMenu.classList.remove('is-open');
      if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
      window.setTimeout(function () { if (searchInput) searchInput.focus(); }, 40);
    }
  }

  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function () { setSearchOpen(searchPanel.hidden); });
    if (searchClose) searchClose.addEventListener('click', function () { setSearchOpen(false); searchToggle.focus(); });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !searchPanel.hidden) { setSearchOpen(false); searchToggle.focus(); }
    });
    document.addEventListener('click', function (event) {
      if (!searchPanel.hidden && !searchPanel.contains(event.target) && !searchToggle.contains(event.target)) setSearchOpen(false);
    });
  }

  if (searchInput && searchResults) {
    searchInput.addEventListener('input', function () {
      window.clearTimeout(searchTimer);
      const term = searchInput.value.trim();
      if (term.length < 2) {
        if (searchRequest) searchRequest.abort();
        searchResults.innerHTML = defaultSearchContent;
        searchResults.classList.remove('is-loading');
        return;
      }
      searchTimer = window.setTimeout(function () {
        if (searchRequest) searchRequest.abort();
        searchRequest = new AbortController();
        searchResults.classList.add('is-loading');
        const url = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
        fetch(url + 'search/suggest?q=' + encodeURIComponent(term) + '&resources[type]=product,collection,page,article&resources[limit]=6&section_id=predictive-search', { signal: searchRequest.signal })
          .then(function (response) { if (!response.ok) throw new Error('Suche nicht erreichbar'); return response.text(); })
          .then(function (html) { searchResults.innerHTML = html; searchResults.classList.remove('is-loading'); })
          .catch(function (error) { if (error.name !== 'AbortError') { searchResults.innerHTML = '<p class="frago-predictive-error">Die Live-Suche ist gerade nicht erreichbar. Mit Enter kannst du trotzdem suchen.</p>'; searchResults.classList.remove('is-loading'); } });
      }, 260);
    });
  }

  document.querySelectorAll('product-recommendations[data-url]').forEach(function (section) {
    if (section.dataset.loaded === 'true') return;
    section.dataset.loaded = 'true';
    fetch(section.dataset.url)
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var documentFragment = new DOMParser().parseFromString(html, 'text/html');
        var recommendations = documentFragment.querySelector('product-recommendations');
        if (recommendations && recommendations.innerHTML.trim()) section.innerHTML = recommendations.innerHTML;
      })
      .catch(function () { section.hidden = true; });
  });

  const params = new URLSearchParams(window.location.search);
  document.querySelectorAll('[data-query-field]').forEach(function (field) {
    const value = params.get(field.dataset.queryField);
    if (value && !field.value) field.value = value;
  });
  const subject = document.querySelector('[data-query-field="betreff"]');
  if (subject && !subject.value && params.get('produkt')) subject.value = 'Produktanfrage: ' + params.get('produkt');

  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    const track = gallery.querySelector('[data-gallery-track]');
    const slides = gallery.querySelectorAll('[data-gallery-slide]');
    const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    const current = gallery.querySelector('[data-gallery-current]');
    let index = 0;
    if (!track || slides.length < 2) return;
    function goTo(next) {
      index = (next + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === index);
        thumb.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      if (current) current.textContent = index + 1;
    }
    gallery.querySelector('[data-gallery-prev]').addEventListener('click', function () { goTo(index - 1); });
    gallery.querySelector('[data-gallery-next]').addEventListener('click', function () { goTo(index + 1); });
    thumbs.forEach(function (thumb) { thumb.addEventListener('click', function () { goTo(Number(thumb.dataset.index)); }); });
    let startX = 0;
    track.addEventListener('touchstart', function (event) { startX = event.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (event) {
      const distance = event.changedTouches[0].clientX - startX;
      if (Math.abs(distance) > 45) goTo(index + (distance < 0 ? 1 : -1));
    }, { passive: true });
    goTo(0);
  });

  document.querySelectorAll('[data-bestseller-slider]').forEach(function (slider) {
    const track = slider.querySelector('[data-bestseller-track]');
    const previous = slider.querySelector('[data-bestseller-prev]');
    const next = slider.querySelector('[data-bestseller-next]');
    if (!track) return;
    function move(direction) {
      const card = track.querySelector('.bestseller-strip-card');
      const distance = card ? card.getBoundingClientRect().width + 12 : track.clientWidth * 0.8;
      track.scrollBy({ left: distance * direction, behavior: 'smooth' });
    }
    if (previous) previous.addEventListener('click', function () { move(-1); });
    if (next) next.addEventListener('click', function () { move(1); });
  });

  document.querySelectorAll('[data-nav-preview-link]').forEach(function (link) {
    function showPreview() {
      const mega = link.closest('.nav-mega');
      const image = mega && mega.querySelector('[data-nav-preview-target]');
      const caption = mega && mega.querySelector('[data-nav-caption-target]');
      if (image && link.dataset.navPreviewImage) {
        image.src = link.dataset.navPreviewImage;
        image.alt = link.textContent.trim();
      }
      if (caption && link.dataset.navPreviewCaption) caption.textContent = link.dataset.navPreviewCaption;
    }
    link.addEventListener('mouseenter', showPreview);
    link.addEventListener('focus', showPreview);
  });

  document.querySelectorAll('[data-hero-slider]').forEach(function (slider) {
    const slides = Array.from(slider.querySelectorAll('[data-hero-slide]'));
    const dots = Array.from(slider.querySelectorAll('[data-hero-dot]'));
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const interval = Number(slider.dataset.heroInterval) || 6000;
    let index = 0;
    let timer;
    let touchStartX = 0;
    if (slides.length < 2) return;
    function show(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (slide, slideIndex) {
        const active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      dots.forEach(function (dot, dotIndex) {
        const active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', String(active));
      });
    }
    function stop() { window.clearInterval(timer); }
    function start() {
      stop();
      if (!reduceMotion) timer = window.setInterval(function () { show(index + 1); }, interval);
    }
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        show(Number(dot.dataset.heroDot));
        start();
      });
    });
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    slider.addEventListener('focusin', stop);
    slider.addEventListener('focusout', start);
    slider.addEventListener('touchstart', function (event) { touchStartX = event.touches[0].clientX; }, { passive: true });
    slider.addEventListener('touchend', function (event) {
      const distance = event.changedTouches[0].clientX - touchStartX;
      if (Math.abs(distance) > 50) {
        show(index + (distance < 0 ? 1 : -1));
        start();
      }
    }, { passive: true });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });
    show(0);
    start();
  });
});
